import React from "react";
import {Row, Col, Container,Breadcrumb } from 'react-bootstrap';
const BreadcrumbsDetail =(props) => {
   
 var searchType = props?.searchType;
 var  buildingType = props?.buildingType;

var  buildingCapitalize = 
buildingType?.charAt(0).toUpperCase()
  + buildingType?.slice(1)

    return(
  <div className="breadcrumb-block text-center mb-4">
    <Container>
        <Row> 
        <Col lg={12}>
        
            <Breadcrumb>
                <Breadcrumb.Item href="/">Bentleyhurst</Breadcrumb.Item>
                {searchType === "sales" ? <Breadcrumb.Item href="/property/for-sale">Properties for sale</Breadcrumb.Item> :
                    searchType === "lettings" ? <Breadcrumb.Item href="/property/to-rent/">Properties to rent</Breadcrumb.Item> : ""
                    }
                
                <Breadcrumb.Item href="#" className="hide-breadcrumb">{buildingCapitalize} {searchType === "sales" ? "for sale" : searchType === "lettings" ? "to rent" : ""}  in {props.propertyArea}</Breadcrumb.Item>   
            </Breadcrumb>
            
        </Col>
        </Row>
    </Container>
  </div>
)
    }

export default BreadcrumbsDetail;

